const numberFormatter = (num, digits) => {

  const actualVal = num

  if (actualVal < 0) num = -num
  num = parseFloat(num)

  const si = [
    {value: 1, symbol: ""},
    {value: 1E3, symbol: "k"},
    {value: 1E6, symbol: "M"},
    {value: 1E9, symbol: "B"},
    {value: 1E12, symbol: "T"},
    {value: 1E15, symbol: "P"},
    {value: 1E18, symbol: "E"}
  ]

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  let i

  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) break
  }

  if (actualVal < 0) return -(num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
  else return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
}

module.exports = {
  numberFormatter
}


// WEBPACK FOOTER //
// ./src/components/view-fincancials/utils.js